/* eslint-disable @angular-eslint/directive-selector */
import { Directive, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, inject } from '@angular/core';
import { fromEvent, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, takeUntil } from 'rxjs/operators';

/**
 * Directive to add debounce functionality to input elements
 * Usage: <input [debounceTime]="500" (debounceInput)="onSearch($event)" />
 */
@Directive({
  selector: '[debounceInput]'
})
export class DebounceInputDirective implements OnInit, OnDestroy {
  @Input() debounceTime = 400; // Default debounce time in milliseconds
  @Output() debounceInput = new EventEmitter<string>();
  
  private destroy$ = new Subject<void>();

  private elementRef = inject<ElementRef<HTMLInputElement>>(ElementRef);

  ngOnInit(): void {
    // Listen to input events on the element
    fromEvent<InputEvent>(this.elementRef.nativeElement, 'input')
      .pipe(
        map((event) => (event.target as HTMLInputElement).value),
        debounceTime(this.debounceTime),
        distinctUntilChanged(),
        takeUntil(this.destroy$)
      )
      .subscribe(value => {
        this.debounceInput.emit(value);
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
